import { productOptions_productOptions_items_ConfigurableProduct_configurable_options_values_swatch_data } from 'src/queries/__generated__/productOptions';

export enum SwatchKind {
    ImageSwatchData = 'ImageSwatchData',
    ColorSwatchData = 'ColorSwatchData',
}

export enum SwatchKindNumerical {
    ImageSwatchData = '2',
    ColorSwatchData = '1',
}

export interface SwatchData {
    kind: SwatchKind | SwatchKindNumerical;
    value: string;
}

export const DEFAULT_COLOR_HEX = '#ffffff';
export const DEFAULT_COLOR_SWATCH: SwatchData = { kind: SwatchKind.ColorSwatchData, value: DEFAULT_COLOR_HEX };
export const DEFAULT_IMG_PREFIX = '/media/attribute/swatch';

export function getSwatchData<T extends { swatch_data: any }>(value: GqlOptionValue<T>): SwatchData | undefined {
    if (!value.swatch_data) return undefined;
    if (!(value.swatch_data.__typename in SwatchKind)) return undefined;
    switch (value.swatch_data.__typename) {
        case 'ImageSwatchData': {
            return { kind: SwatchKind.ImageSwatchData, value: swatchImage(value.swatch_data.value) };
        }
        case 'ColorSwatchData': {
            return { kind: SwatchKind.ColorSwatchData, value: value.swatch_data.value || DEFAULT_COLOR_HEX };
        }
        default:
            return undefined;
    }
}

const DEFAULT_IMAGE = 'https://placehold.it/50';

export function swatchImage(maybePath?: string | null): string {
    if (!maybePath) return DEFAULT_IMAGE;
    if (maybePath[0] === '/') {
        return DEFAULT_IMG_PREFIX + maybePath;
    }
    return DEFAULT_IMAGE;
}

export const swatchCss = (swatchData: SwatchData) => {
    switch (swatchData.kind) {
        case SwatchKind.ImageSwatchData: {
            return { background: `url(${swatchData.value}) center center`, backgroundSize: 'contain' };
        }
        default: {
            return { backgroundColor: swatchData.value };
        }
    }
};

export const swatchCssNumerical = (swatchData: SwatchData) => {
    switch (swatchData.kind) {
        case SwatchKindNumerical.ImageSwatchData: {
            return { background: `url(${swatchData.value}) center center`, backgroundSize: 'contain' };
        }
        default: {
            return { backgroundColor: swatchData.value };
        }
    }
};

export type SwatchCss =
    | {
          background: string;
          backgroundSize: string;
          backgroundColor?: undefined;
      }
    | {
          backgroundColor: string;
          background?: undefined;
          backgroundSize?: undefined;
      };

type GqlOptionValue<
    T extends {
        swatch_data: productOptions_productOptions_items_ConfigurableProduct_configurable_options_values_swatch_data;
    } | null,
> = T;
